import { Route, Switch } from 'react-router-dom';
import { FeedbackComponent } from './Feedback';
import { ProvisionalForm } from './Form';
import { ConfirmationPage } from './Schedule/Confirmation';

export const routes: {
  [name: string]: {
    path: string;
    component: React.ComponentType<any>;
    exact?: boolean;
  };
} = {
  schedulingFeedback: {
    path: '/schedule/:schedulingCode/feedback',
    component: FeedbackComponent,
  },
  schedulingEnd: {
    path: '/schedule/:schedulingCode/end',
    component: ConfirmationPage,
  },
  scheduling: {
    path: '/schedule/:schedulingCode',
    component: ProvisionalForm,
  },
  inboundFeedback: {
    //TODO: name :schedulingCode to something more generic
    path: '/get-started/:schedulingCode/feedback',
    component: FeedbackComponent,
  },
  inboundEnd: {
    path: '/get-started/:schedulingCode/end',
    component: ConfirmationPage,
  },
  inbound: {
    path: '/get-started/:schedulingCode',
    component: ProvisionalForm,
  },
};

function getRouteComponents(): JSX.Element[] {
  return Object.entries(routes).map(([key, route]) => (
    <Route
      key={key}
      exact={route.exact}
      path={route.path}
      component={route.component}
    />
  ));
}

export const InboundRouter: React.FC = () => (
  <Switch>{getRouteComponents()}</Switch>
);
